export default __webpack_public_path__ + "static/media/Footer_logoMerck.c23a43dd.png";